import { Directive, EventEmitter, Input, type OnChanges, type OnDestroy, type OnInit, Output } from '@angular/core';
import { Subject, type Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[ngModelChangeDebounced]',
})
export class ChangeDebounceDirective implements OnInit, OnDestroy, OnChanges {
  @Input()
  debounce = 250;

  @Input()
  ngModel: any;

  @Output()
  ngModelChangeDebounced: EventEmitter<any> = new EventEmitter();

  ngModelUpdate = new Subject<string>();
  subscription: Subscription;

  ngOnInit() {
    // Debounce search
    this.subscription = this.ngModelUpdate
      .pipe(debounceTime(this.debounce), distinctUntilChanged())
      .subscribe((value) => {
        this.ngModelChangeDebounced.emit(value);
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnChanges() {
    this.ngModelUpdate.next(this.ngModel);
  }
}
